// React
import React from 'react';
import { Card, Col, Row } from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  FloatButton,
  SelectInput,
  DropdownDatatable,
} from '../../containers/componentsInjection';

// Utils
import { createData } from './utils/createData';

export const CredentialsNTPage = ({
  city,
  search,
  states,
  columns,
  history,
  handleEdit,
  specialties,
  filteredData,
  handleDelete,
  neighborhoods,
  filtersParams,
  handleDuplicate,
  setActiveStatus,
  getFilterCities,
  setFiltersParams,
  tog_animationLeft,
  handleSearchLocal,
  handleSelectChange,
  getFilterNeighborhoods,
}) => {
  return (
    <PageWrapper title={'Rede Credenciada'}>
      <Row>
        <Col xs={12}>
          <Card>
            <Row className="mt-3 mx-2">
              <Col xs={4} md={4} lg={4}>
                <div className="search-box">
                  <input
                    type="text"
                    id="search"
                    value={search}
                    className="form-control search /"
                    placeholder="Pesquisar..."
                    onChange={(e) => handleSearchLocal(e.target.value)}
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>
              </Col>
            </Row>

            <Row className="mt-3 mx-2">
              <Col xs={3} md={3} lg={3}>
                <SelectInput
                  isClearable
                  inputId="stateInput"
                  name="states"
                  value={
                    filtersParams.state
                      ? {
                          value: filtersParams.state,
                          label: filtersParams.state,
                        }
                      : null
                  }
                  className="form-control"
                  onChange={(eventInput) => {
                    if (!eventInput) {
                      setFiltersParams({
                        city: '',
                        neigh: '',
                        state: '',
                        specialty: '',
                      });
                    } else {
                      handleSelectChange('state', eventInput);
                      getFilterCities(eventInput.value);
                    }
                  }}
                  options={createData(states || [])}
                  placeholder="Estado"
                />
              </Col>
              <Col xs={3} md={3} lg={3}>
                <SelectInput
                  isClearable
                  value={
                    filtersParams.city
                      ? {
                          value: filtersParams.city,
                          label: filtersParams.city,
                        }
                      : null
                  }
                  isDisabled={!filtersParams.state}
                  inputId="cityInput"
                  name="city"
                  className="form-control"
                  onChange={(eventInput) => {
                    if (!eventInput) {
                      setFiltersParams({
                        ...filtersParams,
                        city: '',
                        neigh: '',
                      });
                    } else {
                      handleSelectChange('city', eventInput);
                      getFilterNeighborhoods(eventInput.value);
                    }
                  }}
                  options={city || []}
                  placeholder="Cidade"
                />
              </Col>
              <Col xs={3} md={3} lg={3}>
                <SelectInput
                  isClearable
                  value={
                    filtersParams.neigh
                      ? {
                          value: filtersParams.neigh,
                          label: filtersParams.neigh,
                        }
                      : null
                  }
                  inputId="neighInput"
                  name="neigh"
                  isDisabled={!filtersParams.city}
                  className="form-control"
                  onChange={(eventInput) =>
                    handleSelectChange('neigh', eventInput)
                  }
                  options={neighborhoods || []}
                  placeholder="Bairro"
                />
              </Col>
              <Col xs={3} md={3} lg={3}>
                <SelectInput
                  isClearable
                  value={
                    filtersParams.specialty
                      ? {
                          value: filtersParams.specialty,
                          label: filtersParams.specialty,
                        }
                      : null
                  }
                  inputId="specialties"
                  className="form-control"
                  onChange={(eventInput) =>
                    handleSelectChange('specialty', eventInput)
                  }
                  options={createData(specialties || [])}
                  placeholder="Especialidades"
                />
              </Col>
            </Row>

            <DropdownDatatable
              pagination
              perPage={10}
              persistTableHead
              hasStatusSelect
              canSearch={false}
              columns={columns}
              isSearchRemote={false}
              title="Rede credenciada"
              handleButton={tog_animationLeft}
              data={filteredData.length > 0 ? filteredData : []}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) => handleEdit(cellProps),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
                {
                  id: 2,
                  name: 'duplicate',
                  label: 'Duplicar',
                  onPress: (cellProps) => handleDuplicate(cellProps),
                  icon: 'la-copy',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
              handleStatusSelect={(e) => setActiveStatus(e.target.value)}
            />
          </Card>
        </Col>
      </Row>
      <FloatButton
        handleButton={() => history.push('/rede-credenciada/novo')}
      />
    </PageWrapper>
  );
};
